module.exports = __webpack_public_path__ + "static/media/autodesk.30595b61.png";